import { LockKeyhole, Mail, MapPin, Phone } from 'lucide-react'
import { contactDirectory } from '../data/contact'
import { getLocalizedPath } from '../i18n/routes'
import type { RouteKey } from '../i18n/routes'
import type { UiMessageKey } from '../i18n/ui'
import { useI18n } from '../i18n/I18nProvider'
import { Link } from '../ui/Link'
import { Brand } from './Brand'

const footerNavigation: ReadonlyArray<{ route: RouteKey; label: UiMessageKey }> = [
  { route: 'home', label: 'nav.home' },
  { route: 'vehicles', label: 'nav.vehicles' },
  { route: 'services', label: 'nav.services' },
  { route: 'sellVehicle', label: 'nav.sellVehicle' },
  { route: 'contacts', label: 'nav.contacts' },
]

export function Footer() {
  const { language, t } = useI18n()
  const year = new Date().getFullYear()

  return (
    <footer className="site-footer">
      <div className="page-frame site-footer__main">
        <div className="site-footer__brand">
          <Brand />
          <p>{t('shell.footerIntro')}</p>
        </div>

        <div className="site-footer__navigation">
          <h2>{t('shell.footerNavigation')}</h2>
          <nav aria-label={t('shell.footerNavigationLabel')}>
            <ul>
              {footerNavigation.map((item) => (
                <li key={item.route}>
                  <Link to={getLocalizedPath(item.route, language)}>{t(item.label)}</Link>
                </li>
              ))}
            </ul>
          </nav>
        </div>

        <div className="site-footer__contacts">
          <h2>{t('shell.footerContacts')}</h2>
          <ul>
            <li>
              <MapPin aria-hidden="true" />
              <a href={contactDirectory.office.directionsUrl} target="_blank" rel="noopener noreferrer">
                {contactDirectory.office.streetAddress}<br />{contactDirectory.office.postalAddress}
              </a>
            </li>
            {contactDirectory.phone.map((phone) => (
              <li key={phone}>
                <Phone aria-hidden="true" />
                <a href={`tel:+39${phone.replaceAll(' ', '')}`}>{phone}</a>
              </li>
            ))}
            <li>
              <Mail aria-hidden="true" />
              <a href={`mailto:${contactDirectory.email}`}>{contactDirectory.email}</a>
            </li>
          </ul>
        </div>
      </div>

      <div className="page-frame site-footer__bottom">
        <div className="site-footer__copyright">
          <Link className="site-footer__staff-access" to={`/${language}/login`} aria-label={t('shell.staffArea')} title={t('shell.staffArea')}>
            <LockKeyhole size={14} aria-hidden="true" />
          </Link>
          <p>{t('shell.footerCopyright').replace('{{year}}', String(year))}</p>
        </div>
        <div className="site-footer__legal">
          <Link to={getLocalizedPath('privacy', language)}>{t('common.privacy')}</Link>
        </div>
      </div>
    </footer>
  )
}
